import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';

import type { IFooterUploadHandlerProps } from '@/views/AdminDashboard/components/ExcelImporterStepper/components/Footer/types';

import TeamUploadFileMutation from './graphql/TeamUploadFile.v4.b2b.graphql';
import type {
  TeamUploadFile,
  TeamUploadFileVariables,
} from './graphql/types/TeamUploadFile';

const useTeamUploadFile = () => {
  const { query } = useRouter();
  const { slug } = query as { slug: string };

  const [teamUploadFile, { loading, error }] = useMutation<
    TeamUploadFile,
    TeamUploadFileVariables
  >(TeamUploadFileMutation, {
    context: {
      clientName: 'v4.b2b',
    },
  });

  const handleFileUpload = async (options: IFooterUploadHandlerProps) => {
    const response = await teamUploadFile({
      variables: {
        ...options,
        slug,
      },
    });

    return !!response.data?.workTeamUpload?.success;
  };

  return { loading, error, handleFileUpload };
};

export default useTeamUploadFile;
